import { AdSize, adSizes, AdSizes } from '../../components/presentational/Ad';
import theme from '../../lib/theme';
const { mediaSizes } = theme;

const {
  mobileLeaderboard,
  mediumRectangle,
  halfPage,
  leaderboard,
  mediumBillboard,
  largeLeaderboard,
  largeRectangle,
  fluid,
  billboard,
  video,
  videoMobile,
} = adSizes;

const HIDDEN_ADHESION = process.env.HIDDEN_ADHESION;

const adhesion: AdSize = {
  sizeMapping: [
    { viewport: [0, 0], slot: [mobileLeaderboard] },
    { viewport: [mediaSizes.m, 0], slot: [leaderboard] },
  ],
};

const config: AdSizes = {
  standard_adhesion: HIDDEN_ADHESION
    ? {
        sizeMapping: [
          {
            viewport: [0, 0],
            slot: [video],
          },
        ],
      }
    : adhesion,  
  sticky: {
    sizeMapping: [
      { viewport: [0, 0], slot: [mediumRectangle, mobileLeaderboard, fluid], },
      { viewport: [mediaSizes.m, 0], slot: [mediumRectangle, fluid], },
      { viewport: [mediaSizes.l, 0], slot: [halfPage, mediumRectangle, fluid], },
    ],
  },
  enterprise: {
    sizeMapping: [
      { viewport: [0, 0], slot: [videoMobile, mediumRectangle, fluid], },
      { viewport: [mediaSizes.m, 0], slot: [videoMobile, mediumRectangle, fluid], },
      { viewport: [mediaSizes.l, 0], slot: [halfPage, mediumRectangle, fluid], },
    ],
  },
  top: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [mediumRectangle],
      },
      {
        viewport: [mediaSizes.m, 0],
        slot: [mediumBillboard, leaderboard],
      },
      {
        viewport: [mediaSizes.l, 0],
        slot: [mediumBillboard, billboard, leaderboard],
      },
    ],
  },
  bottom: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [mediumRectangle],
      },
      {
        viewport: [mediaSizes.m, 0],
        slot: [mediumBillboard, leaderboard],
      },
      {
        viewport: [mediaSizes.l, 0],
        slot: [billboard, mediumBillboard, leaderboard],
      },
    ],
  },
  high_impact: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [video],
      },
    ],
  },
  collection_recirculation_native1: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [fluid],
      },
    ],
  },
  collection_recirculation_native2: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [fluid],
      },
    ],
  },
};

export default config;
